// extracted by mini-css-extract-plugin
export var chip = "_av-0";
export var filterDropdown = "_av-5";
export var filterItem = "_av-6";
export var icon = "_av-1";
export var removeButton = "_av-3";
export var removeIcon = "_av-4";
export var separator = "_av-2";